import { chunkArray } from '@openeducation/oe-it-services';
import { useEffect, useState } from 'react';

export interface UseDataTablePaginationResponse {
  from: number;
  to: number;
  numberOfPages: number;
  itemsPerPage: number;
  itemsPerPageList: number[];
  onItemsPerPageChange: (perPage: number) => void;
  page: number;
  onPageChange: (page: number) => void;
  resetPagination: () => void;
  list: any[];
}
export const useDataTablePagination = <T>(
  data: T[],
  numberOfItemsPerPageList: number[] = [10, 25, 50, 100]
): UseDataTablePaginationResponse => {
  const totalItems = data.length;

  const [page, setPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(numberOfItemsPerPageList[0]);
  const from = page * itemsPerPage;
  const to = Math.min((page + 1) * itemsPerPage, totalItems);
  const numberOfPages = Math.ceil(totalItems / itemsPerPage);

  const resetPagination = () => setPage(0);

  useEffect(() => {
    setPage(0);
  }, [totalItems, itemsPerPage]);

  const chunks = chunkArray(data, itemsPerPage);
  return {
    from,
    to,
    numberOfPages,
    itemsPerPage,
    itemsPerPageList: numberOfItemsPerPageList,
    onItemsPerPageChange: setItemsPerPage,
    page,
    onPageChange: setPage,
    resetPagination,
    list: chunks[page],
  };
};
